// removed by extract-text-webpack-plugin
module.exports = {"jumbo_h1":"src-styles----news-module---jumbo_h1---3mWEZ"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/news.module.scss
// module id = 285
// module chunks = 22846268747618 46636455185173